// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1j6qg","title":"Info_title__3OttM","links":"Info_links__3ciuN","link":"Info_link__2lk2J","logo":"Info_logo__2Ym4P"};